// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD_YPdEEnCXw5sPuOUbby8vjzwrCVlCDpo",
  authDomain: "hotel-b4c75.firebaseapp.com",
  projectId: "hotel-b4c75",
  storageBucket: "hotel-b4c75.appspot.com",
  messagingSenderId: "892783386352",
  appId: "1:892783386352:web:5d608bc5b531ded6ceec35",
  measurementId: "G-373KTLQ431"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
